import { TableCell, TableHead, Typography, useTheme } from "@mui/material";
import { ReactElement } from "react";
interface PropType {
  key: string;
  tittle: string;
  children: ReactElement;
}

const TableHeadCell = (props: PropType) => {
  const { key, tittle, children } = props;
  const theme = useTheme();
  return (
    <TableCell
      sx={{
        textAlign: "center",
        verticalAlign: "text-top",
        backgroundColor: theme.color?.tableHeader,
      }}
      key={key}
    >
      <Typography
        sx={{
          whiteSpace: "nowrap",
          fontFamily: theme?.font?.fontFamily.primary,
          fontSize: theme.font?.fontSize.tableHeader,
          color: theme.color?.tableGrey,
          height: "2rem",
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        {tittle}
      </Typography>
      {children}
    </TableCell>
  );
};
export default TableHeadCell;
